import React from 'react';
import GradientButton from '../../customMui/newButton/newButton';

const OppsPopup=({ handleClose }) =>
{

	return (
		<div className='flexCol dialogBD '>
			<div className='flexCol dialogBox pdngBMD'>
				<div className='flexRow jBtwn aCntr brdrBSM pdngMD'>
					<span className='lHdng pdngHXS'>Oops!</span>
					<div className='flexInline pdngHXS '>
						<img
							src='/images/cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={() => handleClose(false)}
						/>
					</div>
				</div>
				<div className='flexCol pdngMD aCntr jCntr'>
					<div className='flexRow pdngVMD jCntr'>
						<img src='/icons/oops.svg' alt='oops' />
					</div>
					<span className='sHdng pdngTSM'>Room is already full, You Cannot be Added to the Conference,</span>
					<span className='sHdng'>We will notify to host, Please try again after some time.</span>
				</div>
				<div className='flexRow aCntr jCntr pdngVSM '>
					<GradientButton
						variant='contained'
						disableElevation
						color='primary'
						style={{ borderRadius: '10px' }}
						onClick={() => handleClose(false)}
					>
						OK
					</GradientButton>
				</div>
			</div>
		</div>
	);
};

export default OppsPopup;
